












































































import { defineComponent, PropType, ref } from '@nuxtjs/composition-api';
import { OfferCardFragment } from '~/graphql/fragments';

export default defineComponent({
  props: {
    banners: {
      type: Array as PropType<OfferCardFragment[]>,
      default: null,
    },
  },
  setup() {
    const activeSlide = ref(0);

    return {
      activeSlide,
    };
  },
});
